import { USER_LANGUAGE } from "../constants/indicafix.constants";

export const userLanguageAdapter = {
  read: () => localStorage.getItem(USER_LANGUAGE),
  write: (language: string) => localStorage.setItem(USER_LANGUAGE, language),
};
